var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6004 5.39922H15.0004L13.8004 4.19922H10.2004L9.00039 5.39922H5.40039V7.79922H18.6004V5.39922ZM6.60039 17.3992C6.60039 18.8092 7.57239 19.7992 9.00039 19.7992H15.0004C16.4284 19.7992 17.4004 18.8092 17.4004 17.3992V8.99922H6.60039V17.3992Z",
    fill: "#006D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.690cda96ab171a979d972acaebaeffff.svg";
export { ForwardRef as ReactComponent };